"use strict";

var KumsalDashboard = function () {

    var pieChart = function (name,data) {
        var kumsalChart = $('.kumsal-pie-chart[data-name="' + name + '"]');
        if (kumsalChart.length == 0) {
            return;
        }

        var randomScalingFactor = function () {
            return Math.round(Math.random() * 100);
        };

        var backgroundColor = [
            KTApp.getStateColor('success'),
            KTApp.getStateColor('danger'),
            KTApp.getStateColor('brand'),
            KTApp.getStateColor('dark'),
            KTApp.getStateColor('primary'),
            KTApp.getStateColor('info'),
        ];

        var config = {
            type: 'doughnut',
            data: {
                datasets: [{
                    data: data[name].values,
                    backgroundColor: backgroundColor
                }],
                labels: data[name].labels
            },
            options: {
                cutoutPercentage: 75,
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    position: 'top',
                },
                title: {
                    display: false,
                    text: 'Technology'
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                },
                tooltips: {
                    enabled: true,
                    intersect: false,
                    mode: 'nearest',
                    bodySpacing: 5,
                    yPadding: 10,
                    xPadding: 10,
                    caretPadding: 0,
                    displayColors: false,
                    backgroundColor: KTApp.getStateColor('brand'),
                    titleFontColor: '#ffffff',
                    cornerRadius: 4,
                    footerSpacing: 0,
                    titleSpacing: 0
                }
            }
        };


        kumsalChart.find('.kumsal-pie-chart-legends').html('');

        $.each(data[name].percantages,function (index,percantage) {
            kumsalChart.find('.kumsal-pie-chart-legends').append('<div class="kt-widget14__legend">\n' +
                '            <span class="kt-widget14__bullet" style="background-color: '+backgroundColor[index]+'";></span>\n' +
                '            <span class="kt-widget14__stats">'+percantage+'</span>\n' +
                '        </div>');
        });


        kumsalChart.find('.kumsal-pie-chart-canvas').parent().html('<canvas class="kumsal-pie-chart-canvas" style="height: 160px; width: 160px;"></canvas>');
        var ctx = kumsalChart.find('.kumsal-pie-chart-canvas')[0].getContext('2d');
        var myDoughnut = new Chart(ctx, config);
    };

    var lineFormat = function (value, type) {
        switch (type) {
            case 'date':
                return moment.duration(Math.round(value), "seconds").humanize();
            case 'percentage':
                return (Math.round(value * 100) / 100) + '%';
            default:
                return value;
        }
    };

    var lineChart = function (name, type, data) {
        var kumsalChart = $('.kumsal-line-chart[data-name="' + name + '"]');
        if (kumsalChart.length == 0) {
            return;
        }

        kumsalChart.find('.kumsal-line-chart-canvas').parent().html('<canvas class="kumsal-line-chart-canvas"></canvas>');

        var ctx = kumsalChart.find('.kumsal-line-chart-canvas')[0].getContext("2d");

        kumsalChart.find('.kumsal-line-chart-total').text(lineFormat(data.total[name], type));

        var gradient = ctx.createLinearGradient(0, 0, 0, 240);
        gradient.addColorStop(0, Chart.helpers.color(KTApp.getStateColor(kumsalChart.data('color'))).alpha(0.4).rgbString());
        gradient.addColorStop(1, Chart.helpers.color(KTApp.getStateColor(kumsalChart.data('color'))).alpha(0.1).rgbString());

        var config = {
            type: 'line',
            data: {
                labels: data.labels,
                datasets: [{
                    label: "Bandwidth Stats",
                    backgroundColor: gradient,
                    //backgroundColor: KTApp.getStateColor(kumsalChart.data('color')),
                    borderColor: KTApp.getStateColor(kumsalChart.data('color')),

                    pointBackgroundColor: Chart.helpers.color('#000000').alpha(0).rgbString(),
                    pointBorderColor: Chart.helpers.color('#000000').alpha(0).rgbString(),
                    pointHoverBackgroundColor: KTApp.getStateColor('danger'),
                    pointHoverBorderColor: Chart.helpers.color('#000000').alpha(0.1).rgbString(),

                    //fill: 'start',
                    data: data.values[name]
                }]
            },
            options: {
                title: {
                    display: false,
                },
                tooltips: {
                    mode: 'nearest',
                    intersect: false,
                    position: 'nearest',
                    xPadding: 10,
                    yPadding: 10,
                    caretPadding: 10,
                    callbacks: {
                        label: function (tooltipItems, data) {
                            return lineFormat(tooltipItems.yLabel, type);
                        }
                    }
                },
                legend: {
                    display: false
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        display: false,
                        gridLines: false,
                        scaleLabel: {
                            display: true,
                            labelString: 'Month'
                        }
                    }],
                    yAxes: [{
                        display: false,
                        gridLines: false,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                elements: {
                    line: {
                        tension: 0.0000001
                    },
                    point: {
                        radius: 4,
                        borderWidth: 12
                    }
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 10,
                        bottom: 0
                    }
                }
            }
        };

        var chart = new Chart(ctx, config);
    };

    var chartInit = function (picker) {
        // demo loading
        var loading = new KTDialog({
            'type': 'loader',
            'placement': 'top center',
            'message': _translation.statistics.loading
        });

        $('.kumsal-chart-portlet').addClass("kt-spinner kt-spinner--v2 kt-spinner--md kt-spinner--info");
        $('.kumsal-chart-portlet').find('.kt-portlet__body').addClass('invisible');

        loading.show();

        $.ajax({
            url: _route['admin.statistics.index'],
            type: 'POST',
            data: {
                start_date: picker.startDate.format('YYYY-MM-DD'),
                end_date: picker.endDate.format('YYYY-MM-DD'),
            }
        }).always(function (response) {
            loading.hide();
            $('.kumsal-chart-portlet').removeClass("kt-spinner kt-spinner--v2 kt-spinner--md kt-spinner--info");
            $('.kumsal-chart-portlet').find('.kt-portlet__body').removeClass('invisible');
            if (typeof response.status === 'boolean' && response.status) {
                $('.kumsal-line-chart').each(function () {
                    lineChart($(this).data('name'),$(this).data('type'), response.line.data);
                });
                $('.kumsal-pie-chart').each(function () {
                    pieChart($(this).data('name'), response.pie);
                });
            } else {

            }
        });
    };

    // Daterangepicker Init
    var daterangepickerInit = function () {
        if ($('#kt_dashboard_daterangepicker').length == 0) {
            return;
        }

        var picker = $('#kt_dashboard_daterangepicker');
        var start = moment();
        var end = moment();

        function cb(start, end, label) {
            var title = '';
            var range = '';

            if ((end - start) < 100 || label == _translation.statistics.ranges.today) {
                title = _translation.statistics.ranges.today + ':';
                range = start.format('MMMM D');
            } else if (label == _translation.statistics.ranges.yesterday) {
                title = _translation.statistics.ranges.yesterday + ':';
                range = start.format('MMMM D');
            } else {
                range = start.format('MMM D') + ' - ' + end.format('MMM D');
            }

            $('#kt_dashboard_daterangepicker_date').html(range);
            $('#kt_dashboard_daterangepicker_title').html(title);
        }

        var ranges = {};

        ranges[_translation.statistics.ranges.today] = [moment(), moment()];
        ranges[_translation.statistics.ranges.yesterday] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
        ranges[_translation.statistics.ranges.last7Days] = [moment().subtract(6, 'days'), moment()];
        ranges[_translation.statistics.ranges.last30Days] = [moment().subtract(29, 'days'), moment()];
        ranges[_translation.statistics.ranges.thisMonth] = [moment().startOf('month'), moment().endOf('month')];
        ranges[_translation.statistics.ranges.lastMonth] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];

        picker.daterangepicker({
            direction: KTUtil.isRTL(),
            startDate: start,
            endDate: end,
            opens: 'left',
            ranges: ranges,
            locale: {
                format: moment.localeData().longDateFormat('L'),
                separator: " - ",
                applyLabel: _translation.daterangepicker.apply,
                cancelLabel: _translation.daterangepicker.cancel,
                customRangeLabel: _translation.daterangepicker.custom,
                weekLabel: _translation.daterangepicker.week,
                daysOfWeek: moment.weekdaysShort(),
                monthNames: moment.months(),
                firstDay: 1
            }
        }, cb);

        cb(start, end, '');

        chartInit(picker.data('daterangepicker'));

        picker.on('apply.daterangepicker', function (ev, picker) {
            chartInit(picker);
        });
    };

    return {
        // Init demos
        init: function () {
            daterangepickerInit();
        }
    };
}();


export default KumsalDashboard;
